import DashboardIcon from "../../../assets/images/generico/DashboardIcon";
import "./CardVideoTutoriales.css";

const CardVideoTutoriales = ({ card }) => {

  return (
    <div className="ptur-cardVideoTutoriales-container">
      <div className="ptur-cardVideoTutoriales-header">
        <span dangerouslySetInnerHTML={{ __html: card.nombre }} />
      </div>
      <div className={`${card.iframe && card.iframe !== "" ? "ptur-cardVideoTutoriales-body" : "ptur-cardVideoTutoriales-bodySinVideo"}`}>
        <span
          className="ptur-cardVideoTutoriales-description"
          dangerouslySetInnerHTML={{ __html: card.descripcion }}
        />
                
          {
            card.iframe && card.iframe !== "" &&
          <embed
            width="100%"
            height="200px"
            src={card.iframe}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></embed>
          }        
          <a href={card.url}  target="_blank">
          <button className="ptur-cardVideoTutoriales-btn">
            
            <span> Ver Video</span>
          </button>
        </a>
      </div>
    </div>
  );
};
export default CardVideoTutoriales;
